/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import Typography from '../../../components/Typography';
import { Stack, useTheme, Divider } from '@mui/material';

interface SeedFormTitleProps {
  title: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  kebabMenu?: React.ReactNode;
}
const SeedFormTitle = ({ title, icon, children, kebabMenu }: SeedFormTitleProps) => {
  const theme = useTheme();
  return (
    <>
      <Stack
        spacing={1}
        paddingX='16px'
        paddingY='24px'
        bgcolor={theme.colors.primary100}
        borderRadius='10px 10px 0px 0px'
      >
        <Stack direction='row' justifyContent='space-between'>
          <Stack direction='row' alignItems={'center'}>
            {icon}
            <Typography variant='h4' color='primary500' fontWeight='bold'>
              {title}
            </Typography>
          </Stack>
          {kebabMenu}
        </Stack>
        {children && <Stack direction='column'>{children}</Stack>}
      </Stack>
      <Divider />
    </>
  );
};

export default SeedFormTitle;
